import { useState } from 'react';

import { SelectInput, YearDrawer } from '@/components/survey/common/ui';

interface Props {
  label: string;
  selectedYear?: number;
  onSelectYear: (year: number) => void;
  openingYear?: number;
}

export const locationYears = Array.from({ length: new Date().getFullYear() - 1969 }, (_, i) => new Date().getFullYear() - i);

export const YearInputDrawer = ({ label, selectedYear, onSelectYear, openingYear }: Props) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const years = locationYears.map((year) => ({
    year,
    disabled: year < (openingYear || 0)
  }));

  return (
    <>
      <SelectInput label={label} value={selectedYear ? `${selectedYear}` : ''} onClick={() => setOpenDrawer(true)} />

      <YearDrawer isVisible={openDrawer} onClose={handleCloseDrawer} title={'연도를 선택해주세요'} items={years} onSelectYear={(year) => onSelectYear(year)} />
    </>
  );
};
